import * as React from "react";
const SvgFiRrTerminal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-terminal_svg__a)">
      <path
        fill="#062147"
        d="M9.13 9.89a3.006 3.006 0 0 1 0 4.23L1.72 21.7c-.2.2-.46.3-.72.3a.96.96 0 0 1-.7-.29.996.996 0 0 1-.02-1.41l7.41-7.59c.4-.4.4-1.03 0-1.42L.28 3.7A.987.987 0 0 1 .3 2.29a.996.996 0 0 1 1.41.02L9.12 9.9zM23 20H11c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-terminal_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTerminal;
